import {all, fork} from 'redux-saga/effects';

import productClickSaga from './productClick';
import categorySaga from './category';
import cartSaga from './cart';
import EECCartEvents from './EECCartEvents/EECCartEvents';
import checkoutOptionSaga from './checkout/checkoutOption';
import reduceImpressionsSaga from './reduce';
import wishlistSaga from './wishlist';

/**
 * Support saga function for category
 */
export default function* EECAnalyticsSaga() {
    yield all([
        fork(categorySaga),
        fork(productClickSaga),
        fork(EECCartEvents),
        fork(cartSaga),
        fork(checkoutOptionSaga),
        fork(reduceImpressionsSaga),
        fork(wishlistSaga),
    ]);
}
